import { LOGTYPE, SendLogRequest } from '@/Data/Functions/SeqLogger';

const MAX_FILE_SIZE = 10485760;

export default {
    methods: {
        LogToSeq(log) {
            SendLogRequest(log);
        },
        logError(message) {
            this.LogToSeq({
                LogType: LOGTYPE.Error,
                LogMessage: message
            });
        },
        logWarning(message) {
            this.LogToSeq({
                LogType: LOGTYPE.Warning,
                LogMessage: message
            });
        },
        logInformation(message) {
            this.LogToSeq({
                LogType: LOGTYPE.Information,
                LogMessage: message
            });
        },
        validateFileSize(file) {
            return file && file.size <= MAX_FILE_SIZE;
        }
    }
};
